<template>
   <div>
      <v-data-table :headers="headers" :items="listitems" sort-by="no" class="border" hide-default-footer dense>
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-toolbar-title>Positions</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
            <v-btn color="primary" dark class="mb-2" @click="additem">New Item</v-btn>
          </v-toolbar>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-icon small class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
          <v-icon small @click="deleteItem(item)">mdi-delete</v-icon>
        </template>
      </v-data-table>

      <v-dialog v-model="dlgedit" width="600" persistent>
         <v-card>
            <v-card-title>Edit Position</v-card-title>
            <v-card-text>
               <v-form v-model="isvalid">
                  <v-select
                    v-model="selectedNominationPositionId"
                    :items="nominationOptions"
                    item-value="id"
                    item-text="title"
                    label="Link to Nomination Position (optional)"
                    hint="Link this so you can sync candidates from nomination results."
                    persistent-hint
                    clearable
                    outlined
                    dense
                    class="mb-3"
                  ></v-select>
                  <v-jsf v-model="formmodel" :schema="formschema" :options="formoptions"/>
               </v-form>
            </v-card-text>
            <v-card-actions class="pb-3">
               <v-spacer></v-spacer>
               <v-btn color="primary" @click="updateItem">Update</v-btn>
               <v-btn color="success" @click="dlgedit = false">Close</v-btn>
            </v-card-actions>
         </v-card>
      </v-dialog>

      <v-dialog v-model="dlgadd" width="600" persistent>
         <v-card>
            <v-card-title>New Position</v-card-title>
            <v-card-text>
               <v-form v-model="isvalid">
                  <v-select
                    v-model="selectedNominationPositionId"
                    :items="nominationOptions"
                    item-value="id"
                    item-text="title"
                    label="Link to Nomination Position (optional)"
                    hint="Link this so you can sync candidates from nomination results."
                    persistent-hint
                    clearable
                    outlined
                    dense
                    class="mb-3"
                  ></v-select>
                  <v-jsf v-model="formmodel" :schema="formschema" :options="formoptions"/>
               </v-form>
            </v-card-text>
            <v-card-actions class="pb-3">
               <v-spacer></v-spacer>
               <v-btn color="primary" @click="createItem">Add</v-btn>
               <v-btn color="success" @click="dlgadd = false">Close</v-btn>
            </v-card-actions>
         </v-card>
      </v-dialog>

      <v-dialog v-model="dlgconfirm" width="400" persistent dark>
         <v-card>
            <v-card-title class="title"><span class="text-white">Confirm you want to delete this?</span></v-card-title>
            <v-card-text>
               <v-row dense>
                  <v-col cols="12" md="3" sm="3"><small><b>Title</b></small></v-col>
                  <v-col cols="12" md="9" sm="9"><small>{{ (todelete) ? todelete.title : '' }}</small></v-col>
               </v-row>
            </v-card-text>
            <v-card-actions>
               <v-spacer></v-spacer>
               <v-btn color="red darken-1" dark @click="dodelete(todelete)">Yes</v-btn>
               <v-btn color="primary" dark @click="closeconfirm">No</v-btn>
            </v-card-actions>
         </v-card>
      </v-dialog>
   </div>
</template>

<script>
const axios = require('axios')
import VJsf from '@koumoul/vjsf/lib/VJsf.js'
import '@koumoul/vjsf/lib/VJsf.css'
import '@koumoul/vjsf/lib/deps/third-party.js'
import ElectionPositionModel from '../Forms/ElectionPositionModel.js'
import ElectionPositionSchema from '../Forms/ElectionPositionSchema.js'
import GeneralOptions from '../Forms/GeneralOptions.js'

export default {
   name: "TableElectionPositions",
   components: { VJsf },

   props: {
      electid: {
         type: [Number, String],
         default: null,
      },
   },

   data: () => ({
      errors: null,
      headers: [
         { text: "No.", align: "start", sortable: true, width: "70", value: "no" },
         { text: "Title", sortable: false, value: "title" },
         { text: "Linked Nomination", sortable: false, value: "linked_nomination_title" },
         { text: "Vote Type", sortable: false, value: "votetype" },
         { text: "No. of Votes", sortable: false, value: "noofvotes" },
         { text: "Order", sortable: false, value: "orderseq" },
         { text: "Actions", value: "actions", align: "end", sortable: false }
      ],
      listitems: [],
      dlgconfirm: false,
      dlgedit: false,
      dlgadd: false,
      todelete: null,
      editedRecordId: null,
      selectedNominationPositionId: null,
      formmodel: ElectionPositionModel,
      formschema: ElectionPositionSchema,
      formoptions: GeneralOptions,
      isvalid: false,
      nominationOptions: [],
   }),

   mounted() {
      this.loadNominationOptions()
   },

   watch: {
      electid: {
         immediate: true,
         handler(newVal) {
            if (newVal) {
               this.initialize()
            } else {
               this.listitems = []
            }
         },
      },
   },

   methods: {
      initialize() {
         if (!this.electid) {
            this.listitems = []
            return
         }
         axios.get('/admin/agm/electionpositions/' + this.electid)
            .then(({ data }) => {
               this.listitems = data.status === 'OK' && Array.isArray(data.data)
                  ? data.data.map((item, idx) => ({ ...item, no: idx + 1 }))
                  : []
            })
            .catch(() => { this.errors = 'Unable to load positions.' })
      },

      loadNominationOptions() {
         axios.get('/admin/nominations/options')
            .then(({ data }) => {
               this.nominationOptions = data.status === 'OK' && Array.isArray(data.data) ? data.data : []
            })
            .catch(() => { this.nominationOptions = [] })
      },

      additem() {
         this.formmodel = { title: "", description: "", votetype: "S", noofvotes: 1, orderseq: this.listitems.length + 1 }
         this.selectedNominationPositionId = null
         this.dlgadd = true
      },

      createItem() {
         const payload = { ...this.formmodel, electid: this.electid, nomination_position_id: this.selectedNominationPositionId }
         axios.post('/admin/agm/electionposition/add', payload)
            .then(({ data }) => {
               if (data.status !== 'OK') { this.errors = data.error; return }
               this.dlgadd = false
               this.initialize()
            })
            .catch(() => { this.errors = 'Unable to add position.' })
      },

      editItem(pItem) {
         this.editedRecordId = pItem.id
         this.formmodel = {
            title: pItem.title || "",
            description: pItem.description || "",
            votetype: pItem.votetype || "S",
            noofvotes: pItem.noofvotes || 1,
            orderseq: pItem.orderseq || 1,
         }
         this.selectedNominationPositionId = pItem.nomination_position_id || null
         this.dlgedit = true
      },

      updateItem() {
         const payload = { ...this.formmodel, id: this.editedRecordId, nomination_position_id: this.selectedNominationPositionId }
         axios.post('/admin/agm/electionposition/update', payload)
            .then(({ data }) => {
               if (data.status !== 'OK') { this.errors = data.error; return }
               this.dlgedit = false
               this.editedRecordId = null
               this.initialize()
            })
            .catch(() => { this.errors = 'Unable to update position.' })
      },

      closeconfirm() { this.todelete = null },
      deleteItem(pItem) { this.todelete = pItem; this.dlgconfirm = true },

      dodelete(pItem) {
         axios.post('/admin/agm/electionposition/delete', { id: pItem.id })
            .then(() => {
               this.dlgconfirm = false
               this.todelete = null
               this.initialize()
            })
            .catch(() => { this.errors = 'Unable to delete position.' })
      },
   },
}
</script>